import { Box, Icon, SpacerNew, TextNew } from '@jfs/ui-new'
import { SkeletonPlaceHolder } from '@jfs/ui-new/src/comps/SkeletonPlaceHolder'
import { FC } from 'react'
import { AepsButton } from '../../comps/AepsButton'

export const PlanCardSkeleton: FC = () => (
  <Box padding={15} marginBottom={12} borderRadius={8} backgroundColor={'WHITE'} shadowType={'shadowPrimary'}>
    <SkeletonPlaceHolder>
      {/* 1. Placeholder for the Title/Amount */}
      {/* Use a fixed height and width to represent text line */}
      <Box width="80%" height={18} borderRadius={4} marginBottom={15} />
      <Box width="60%" height={18} borderRadius={4} marginBottom={15} />
      <Box width="20%" height={18} borderRadius={4} marginBottom={15} />

      {/* 2. Placeholder for the metrics (Validity, Data, Talktime) */}
      <Box flexDirection="row" justifyContent="space-between" width="100%" marginTop={10}>
        {[...Array(3)].map((_, i) => (
          <Box key={i} alignItems="center" flex={1} paddingHorizontal={5}>
            {/* Placeholder for Icon/Image (Circle) */}
            <Box width={30} height={30} borderRadius={15} marginBottom={5} />
            <Box width="80%" height={10} borderRadius={2} marginBottom={5} />
            <Box width="60%" height={10} borderRadius={2} marginBottom={5} />
            <Box width="60%" height={10} borderRadius={2} />
          </Box>
        ))}
      </Box>
    </SkeletonPlaceHolder>
  </Box>
)

export const PlanSkeletonList: FC = () => (
  <Box paddingHorizontal={16} paddingVertical={10}>
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
  </Box>
)
export const ShimmerEffect: FC = () => (
  <Box paddingHorizontal={16} paddingVertical={10}>
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
    <PlanCardSkeleton />
  </Box>
)

export const DashboardCardLoader: FC = () => (
  <Box paddingHorizontal={16} paddingVertical={10}>
    <PlanCardSkeleton />
  </Box>
)

interface ErrorStateProps {
  message: string
  onRetry: () => void
}

export const ErrorState: FC<ErrorStateProps> = ({ message, onRetry }) => (
  <Box flex={1} justifyContent="center" alignItems="center" padding={20}>
    <Icon id="STATUS_FAILED" size={48} color="RED" />
    <SpacerNew size={15} />
    <TextNew fontSize={16} color="BLACK" fontWeight="bold" textAlign="center">
      Error Fetching Plans Data
    </TextNew>
    <SpacerNew size={5} />
    <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1" textAlign="center">
      {message}
    </TextNew>
    <SpacerNew size={20} />
    <AepsButton onPress={onRetry} title="Try Again" disabled={false} borderRadius={15} />
  </Box>
)

export const NoPlansState: FC = () => (
  <Box flex={1} justifyContent="center" alignItems="center" padding={20}>
    <Icon id="INFO" size={48} color="BRAND_COLOR_GRAY_1" />
    <SpacerNew size={15} />
    <TextNew fontSize={16} color="BLACK" fontWeight="bold" textAlign="center">
      No Plans Available
    </TextNew>
    <SpacerNew size={5} />
    <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1" textAlign="center">
      We could not find any prepaid plans for this operator/circle.
    </TextNew>
  </Box>
)
